import Link from "next/link";
import React from "react";

const ExtraPageFooter = () => {
  return (
    <div className='bg-info py-3 py-lg-5 help-section-row'>
      <div className='container'>
        <div className='row d-flex align-items-center justify-content-between'>
          <div className='col-auto'>
            <h3>Haven’t found the right part?</h3>
            <p>Try searching again or find your nearest Ryco reseller.</p>
          </div>
          <div className='col-auto'>
            <Link href='/search/-/-' legacyBehavior>
              <a className='btn btn-outline me-2'>Search</a>
            </Link>
            <Link href='/-/where-to-buy' legacyBehavior>
              <a className='btn btn-primary'>where to buy</a>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExtraPageFooter;
